// Normalize answer text before react-markdown.
// The backend emits LaTeX with \( … \) (inline) and \[ … \] (block) delimiters, but remark-math
// only recognizes $ … $ / $$ … $$. Convert them so rehype-katex can render the math, and trim the
// stray newlines the BE puts right inside \[ … \] blocks.
export const preprocessAnswer = (input: string): string => {
  if (!input) return '';
  return (
    input
      // Escape literal $ (currency etc.) FIRST so remark-math doesn't treat "$5 ... $10" as math.
      // Only the $ delimiters we synthesize below (from \( \) / \[ \]) should be math.
      .replace(/\$/g, '\\$')
      // tidy newlines hugging block-math delimiters (was `cleanLatex`)
      .replace(/\\\[\s*\n/g, '\\[')
      .replace(/\n\s*\\\]/g, ' \\]')
      // \[ ... \]  ->  $$ ... $$   (block)
      .replace(/\\\[([\s\S]*?)\\\]/g, (_m, expr) => `\n$$\n${expr.trim()}\n$$\n`)
      // \( ... \)  ->  $ ... $     (inline)
      .replace(/\\\(([\s\S]*?)\\\)/g, (_m, expr) => `$${expr.trim()}$`)
      .trim()
  );
};
